export const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    margin: '0 auto',
    maxWidth: '100%',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      overflow: 'hidden',
    },
  },
  testimonialContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    padding: '24px',
    backgroundColor: '#4F5B94',
    borderRadius: '20px',
    minHeight: '300px',
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      minHeight: '324px',
    },
  },
  testimonialText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    animation: '$slideIn 0.5s ease-out',
    height: 'calc(100% - 24px)',
    justifyContent: 'space-between',
  },
  icon: {
    width: '24px',
    height: '24px',
    animation: '$slideIn 0.5s ease-ouTht',
  },
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(100px)',
      opacity: 0,
    },
    '100%': {
      transform: 'translateX(0)',
      opacity: 1,
    },
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },
  logo: {
    filter: 'brightness(0) invert(1)',
    width: '110px',
    height: '20px',
  },
  message: {
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '150%',
    color: '#FFFFFF',
  },
  author: {
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '150%',
    color: '#FFFFFF',
  },
  role: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '150%',
    color: '#FFFFFF',
  },
  sliderContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px 0',
    height: '24px',
    position: 'relative',
  },
  dotsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    position: 'relative',
    zIndex: 1,
  },
  slider: {
    position: 'absolute',
    width: 28,
    height: 8,
    backgroundColor: '#00112B',
    borderRadius: '10px',
    zIndex: 2,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '10px',
    backgroundColor: '#E2E2FC',
    transition: 'background-color 0.3s ease',
    cursor: 'pointer',
  },
  activeDot: {
    backgroundColor: '#00112B',
  },
})
